import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { LoteImportacaoBanco } from '../models/lote-importacao-banco';
import { LancamentosLoteImportacaoParaDesfazer } from '../models/lancamentos-lote-importacao-para-desfazer';

@Injectable({
  providedIn: 'root'
})
export class DesfazerImportacaoApiService extends ApiService {

  baseUrlRoute: string = "lancamento-banco";

  constructor(
    public override http: HttpClient,
  ) {
    super(http);
  }

  public listarLotesImportacaoCartao(contaBancoId: number): Observable<LoteImportacaoBanco[]> {
    return this.get<LoteImportacaoBanco[]>(`/${this.baseUrlRoute}/lotes-importacao-cartao/${contaBancoId}`);
  }

  public obterLancamentosLoteImportacaoBanco(contaBancoId: number): Observable<LancamentosLoteImportacaoParaDesfazer> {
    return this.get<LancamentosLoteImportacaoParaDesfazer>(`/${this.baseUrlRoute}/lancamentos-lote-importacao-banco/${contaBancoId}`);
  }

  public obterLancamentosLoteImportacaoCartao(loteImportacaoBancoId: number): Observable<LancamentosLoteImportacaoParaDesfazer> {
    return this.get<LancamentosLoteImportacaoParaDesfazer>(`/${this.baseUrlRoute}/lancamentos-lote-importacao-cartao/${loteImportacaoBancoId}`);
  }

  public desfazerUltimaImportacaoBanco(contaBancoId: number): Observable<void> {
    return this.post<void>(`/${this.baseUrlRoute}/desfazer-importacao-banco/${contaBancoId}`);
  }

  public desfazerImportacaoCartao(contaBancoId: number, loteImportacaoBancoId: number): Observable<void> {
    return this.post<void>(`/${this.baseUrlRoute}/desfazer-importacao-cartao`, null, { contaBancoId, loteImportacaoBancoId });
  }
}
